import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { formatDate } from '@/lib/formatUtils';

interface ActionBarProps {
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onPrintClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportDataClick?: () => void;
  onEditPrintTemplateClick?: () => void;
  className?: string;
  searchParams?: BanHangSearchParams;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onFixedColumnsClick,
  onExportDataClick,
  onEditPrintTemplateClick,
  className,
  searchParams
}) => {
  // Create display text following the pattern: "Tài khoản: {ma_tk}, từ ngày {ngay_ct1} đến ngày {ngay_ct2}"
  const getDisplayText = () => {
    if (!searchParams) return '';

    const accountCode = searchParams.tk || '';
    // Use formatDate from utils and convert to slash format for display
    const fromDate = formatDate(searchParams.ngay_ct1)?.replace(/-/g, '/') || '';
    const toDate = formatDate(searchParams.ngay_ct2)?.replace(/-/g, '/') || '';

    let displayText = '';
    if (accountCode) {
      displayText += `Tài khoản: ${accountCode}`;
    }
    if (fromDate && toDate) {
      if (displayText) displayText += ', ';
      displayText += `từ ngày ${fromDate} đến ngày ${toDate}`;
    }

    return displayText;
  };

  const displayText = getDisplayText();

  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Sổ chi tiết công nợ nhiều khách hàng</h1>
          {displayText && (
            <div className='text-[10px] text-gray-500'>
              <p>
                <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
                <span className='font-semibold'>{displayText}</span>
              </p>
            </div>
          )}
        </div>
      }
    >
      {onSearchClick && (
        <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} variant='primary' />
      )}
      <MenuButtonV2
        title='In ấn'
        icon={<Lineicons aria-hidden='true' icon={PrinterStroke} />}
        items={[
          {
            title: 'Sổ chi tiết công nợ nhiều khách hàng',
            icon: <AritoIcon icon={20} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          },
          {
            title: 'Sổ chi tiết công nợ nhiều khách hàng (ngoại tệ)',
            icon: <AritoIcon icon={20} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          },
          {
            title: 'Sổ chi tiết công nợ nhiều khách hàng',
            icon: <AritoIcon icon={18} />,
            onClick: onEditPrintTemplateClick,
            group: 1
          },
          {
            title: 'Sổ chi tiết công nợ nhiều khách hàng (song ngữ)',
            icon: <AritoIcon icon={18} />,
            onClick: onEditPrintTemplateClick,
            group: 1
          },
          {
            title: 'Sổ chi tiết công nợ nhiều khách hàng (ngoại tệ)',
            icon: <AritoIcon icon={18} />,
            onClick: onEditPrintTemplateClick,
            group: 2
          },
          {
            title: 'Sổ chi tiết công nợ nhiều khách hàng (ngoại tệ, song ngữ)',
            icon: <AritoIcon icon={18} />,
            onClick: onEditPrintTemplateClick,
            group: 2
          }
        ]}
      />
      {/* No print button */}
      {onRefreshClick && (
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefreshClick}
          variant='destructive'
        />
      )}
      {onFixedColumnsClick && (
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
      )}
      {onExportDataClick && (
        <ActionButtonV2
          icon={Download1Stroke}
          title='Kết xuất dữ liệu'
          onClick={onExportDataClick}
          variant='secondary'
        />
      )}
      <MenuButtonV2
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          },
          {
            title: 'Kết xuát dữ liệu',
            icon: <AritoIcon icon={18} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
